import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../material/material.module';
import { Payment } from '../../../core/generated';
import { EnumDescriptionPipe } from '../../pipes/enum-description.pipe';
import { CommonModule } from '@angular/common';

export interface PaymentDetailsDialogData {
  payment: Payment;
}

@Component({
  selector: 'app-payment-details-dialog',
  standalone: true,
  imports: [MaterialModule, EnumDescriptionPipe, CommonModule],
  templateUrl: './payment-details-dialog.component.html',
  styleUrl: './payment-details-dialog.component.scss'
})
export class PaymentDetailsDialogComponent {
  private dialogRef = inject(MatDialogRef<PaymentDetailsDialogComponent>);

  constructor(@Inject(MAT_DIALOG_DATA) public data: PaymentDetailsDialogData) {}

  onClose(): void {
    this.dialogRef.close();
  }

  formatDate(date?: string): string {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('pt-BR');
  }

  formatPrice(price?: number): string {
    if (price === undefined || price === null) return 'R$ 0,00';
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(price);
  }

  getInstallmentsCount(): number {
    return this.data.payment.installments?.length || 0;
  }

  getStatusBadgeClass(status?: string): string {
    const statusMap: { [key: string]: string } = {
      'PENDING': 'badge-warning',
      'PARTIALLY_PAID': 'badge-info',
      'PAID': 'badge-success',
      'FAILED': 'badge-error',
      'OVERDUE': 'badge-error'
    };
    return status ? statusMap[status] || 'badge-default' : 'badge-default';
  }

  getPaidInstallmentsCount(): number {
    return (this.data.payment.installments || []).filter(i => i.status === 'PAID').length;
  }

  getProgressPercentage(): number {
    const total = this.getInstallmentsCount() || 1;
    const paid = this.getPaidInstallmentsCount();
    return (paid / total) * 100;
  }
}
